import type { JSX } from 'react';
import { ChevronLeftRegular, ChevronRightRegular } from '@fluentui/react-icons';
import { dateForOffset, useApp } from '../state/app.js';

// 날짜 네비게이터 — 전역 dateOffset 제어. 날짜 영향이 있는 화면(보드/출퇴근 현황) 카드 헤더에서 사용.
export function DateNav(): JSX.Element {
  const { dateOffset, setDateOffset } = useApp();
  const { label } = dateForOffset(dateOffset);
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <div style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #D1D5DB', borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
        <button onClick={() => setDateOffset(dateOffset - 1)} style={btn} aria-label="이전 날"><ChevronLeftRegular fontSize={16} /></button>
        <div style={{ padding: '6px 11px', fontSize: 13, fontWeight: 600, borderLeft: '1px solid #EDEFF2', borderRight: '1px solid #EDEFF2', whiteSpace: 'nowrap' }}>{label}</div>
        <button onClick={() => setDateOffset(dateOffset + 1)} style={btn} aria-label="다음 날"><ChevronRightRegular fontSize={16} /></button>
      </div>
      {dateOffset !== 0 && (
        <button onClick={() => setDateOffset(0)} className="dx-btn dx-btn-ghost" style={{ fontSize: 13, padding: '6px 12px' }}>오늘</button>
      )}
    </div>
  );
}

const btn = { border: 'none', background: '#fff', padding: '6px 8px', cursor: 'pointer', color: '#6B7280', display: 'inline-flex', alignItems: 'center' } as const;
